import React from 'react';

const NoteMessage = ({ message }) => (
  <>{ !!message && <div className="note-message">{ message }</div> }</>
);

export default NoteMessage;
